import { RouteObject } from "react-router-dom";

export const merchantEmailRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Merchant Emails" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { MerchantEmailDashboard } =
            await import("./merchant-email-dashboard");
          return { Component: MerchantEmailDashboard };
        },
      },
      {
        path: "new",
        async lazy() {
          const { MerchantEmailEditor } =
            await import("./merchant-email-editor");
          return { Component: MerchantEmailEditor };
        },
      },
      {
        path: ":campaignId/edit",
        async lazy() {
          const { MerchantEmailEditor } =
            await import("./merchant-email-editor");
          return { Component: MerchantEmailEditor };
        },
      },
    ],
  },
];
